<template>
  <div class="grid" :style="{ gap: gap, gridTemplateColumns: `repeat(${columns}, minmax(0px, 1fr))` }">
    <slot />
  </div>
</template>

<script>
/**
 * @description: 网格布局
 * 使用案例
 * 1. defaultColumns:4 适用于五个搜索条件，其中一个是时间区间搜索的情况
 * 2. defaultColumns1600:5,defaultColumns1500:3 适用于四个搜索条件，其中一个是时间区间搜索的情况
 * 3. defaultColumns1400:4 适用于两个搜索条件/六个搜索条件且有一个时间区间搜索的情况
 * 4. defaultColumns1600:5,defaultColumns1400:4,defaultColumns1300:2 适用于三个搜索条件且有时间区间搜索的情况
 * 5. defaultColumns:4,defaultColumns1400:4 适用于6个搜索条件且有两个时间区间搜索的情况
 */
export default {
  props: {
    // 间隔
    gap: {
      type: String,
      default: '0px 80px',
    },
    defaultColumns: {
      type: Number,
      default: 5,
    },
    defaultColumns1600: {
      type: Number,
      default: 4,
    },
    defaultColumns1500: {
      type: Number,
      default: 4,
    },
    defaultColumns1400: {
      type: Number,
      default: 3,
    },
    defaultColumns1300: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      columns: this.defaultColumns,
    }
  },
  created() {},
  mounted() {
    this.resize()
    // 监听屏幕变化
    window.addEventListener('resize', e => {
      this.resize(e)
    })
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', e => {
      this.resize(e)
    })
  },
  methods: {
    // 监听屏幕变化
    resize(e) {
      let width = e ? e.target.innerWidth : window.innerWidth
      switch (!!width) {
        case width < 1000:
          this.columns = 1
          break
        case width >= 1000 && width < 1300:
          this.columns = this.defaultColumns1300
          break
        case width >= 1300 && width < 1400:
          this.columns = this.defaultColumns1400
          break
        case width >= 1400 && width < 1500:
          this.columns = this.defaultColumns1500
          break
        case width >= 1500 && width < 1600:
          this.columns = this.defaultColumns1600
          break
        case width >= 1600:
          this.columns = this.defaultColumns
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
/**
 * 搜素栏样式
 */
.grid {
  display: grid;
  /* IE repeat syntax */
  display: -ms-grid;
  -ms-gap: 0px 40px;
  -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;
}
</style>
